// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__1DvW7","text":"SelectPayment_text__2fAcx","title":"SelectPayment_title__3Sc6i","btn":"SelectPayment_btn__1AX_Y"};